/* YouPrint theme scripts — no dependencies */
document.documentElement.classList.add('js');
(function () {
  'use strict';

  var money = function (cents, format) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '{{amount}}').replace('{{amount}}', v).replace('{{amount_with_comma_separator}}', v);
  };

  /* ---- Mobile nav ---- */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-burger]');
    if (!burger) return;
    var nav = document.querySelector('[data-nav]');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  });

  /* ---- Mega menu: only one open, overlay, esc, outside click ---- */
  var overlay = document.querySelector('[data-nav-overlay]');
  var megas = function () { return Array.prototype.slice.call(document.querySelectorAll('.nav__item[data-mega]')); };

  function closeAllMega(except) {
    megas().forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
    var any = megas().some(function (d) { return d.hasAttribute('open'); });
    if (overlay) overlay.classList.toggle('is-open', any);
  }

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('.nav__item[data-mega]')) return;
    if (d.open) closeAllMega(d); else closeAllMega();
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest('.nav__item[data-mega]')) return;
    if (window.innerWidth > 860) closeAllMega(null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllMega(null); });

  /* Hover-open on desktop, matching the reference UX */
  document.addEventListener('mouseover', function (e) {
    if (window.innerWidth <= 860) return;
    var item = e.target.closest('.nav__item[data-mega]');
    if (item && !item.open) { item.setAttribute('open', ''); }
  });
  var navRoot = document.querySelector('[data-nav]');
  if (navRoot) {
    navRoot.addEventListener('mouseleave', function () {
      if (window.innerWidth > 860) closeAllMega(null);
    });
  }

  /* ---- Tabs ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tab]');
    if (!btn) return;
    var group = btn.closest('[data-tabs]');
    if (!group) return;
    group.querySelectorAll('[data-tab]').forEach(function (b) {
      b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
    });
    group.querySelectorAll('[data-tabpanel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-tabpanel') !== btn.getAttribute('data-tab');
    });
  });

  /* ---- Read more ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-readmore]');
    if (!b) return;
    var t = document.getElementById(b.getAttribute('data-readmore'));
    if (!t) return;
    var open = t.classList.toggle('is-open');
    b.textContent = open ? 'show less' : 'show more';
  });

  /* ---- Copy promo code ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var text = b.getAttribute('data-copy');
    if (navigator.clipboard) navigator.clipboard.writeText(text);
    var old = b.getAttribute('aria-label');
    b.setAttribute('aria-label', 'Copied');
    setTimeout(function () { b.setAttribute('aria-label', old || 'Copy code'); }, 1600);
  });

  /* ---- Countdown ---- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) return;
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { el.textContent = ''; return; }
      var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), m = Math.floor(diff % 36e5 / 6e4);
      el.innerHTML = 'Ends in <b>' + d + 'd</b> <b>' + ('0' + h).slice(-2) + 'h</b> <b>' + ('0' + m).slice(-2) + 'm</b>';
      setTimeout(tick, 30000);
    }
    tick();
  });

  /* ---- PDP gallery ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gallery-thumb]');
    if (!t) return;
    var wrap = t.closest('[data-gallery]');
    var main = wrap.querySelector('[data-gallery-main] img');
    var src = t.getAttribute('data-src');
    if (main && src) { main.src = src; main.srcset = ''; }
    wrap.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
      b.setAttribute('aria-current', b === t ? 'true' : 'false');
    });
  });

  /* ---- PDP: options + quantity tiers ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var data = form.querySelector('[data-variants]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }
    var fmt = form.getAttribute('data-money-format') || '{{amount}}';
    var idInput = form.querySelector('[name="id"]');
    var priceEl = form.querySelector('[data-price-now]');
    var unitEl = form.querySelector('[data-price-unit]');
    var addBtn = form.querySelector('[data-add]');
    var selects = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));
    var qtySelect = null;
    var qtyIndex = -1;
    var tierRows = Array.prototype.slice.call(form.querySelectorAll('[data-tier-value]'));

    if (tierRows.length) {
      // the hidden select that drives the tier list
      selects.forEach(function (s) {
        if (s.classList.contains('visually-hidden')) { qtySelect = s; qtyIndex = parseInt(s.getAttribute('data-option-index'), 10); }
      });
    }

    function parseQty(str) {
      var m = String(str).replace(/,/g, '').match(/(\d+)/);
      return m ? parseInt(m[1], 10) : 1;
    }

    function findVariant(overrideIndex, overrideValue) {
      var wanted = [];
      selects.forEach(function (s) {
        wanted[parseInt(s.getAttribute('data-option-index'), 10)] = s.value;
      });
      if (overrideIndex != null) wanted[overrideIndex] = overrideValue;
      return variants.filter(function (v) {
        return wanted.every(function (val, i) { return val == null || v.options[i] === val; });
      })[0];
    }

    function render() {
      var chosen = findVariant();
      if (!chosen) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        if (priceEl) priceEl.textContent = '—';
        return;
      }
      if (idInput) idInput.value = chosen.id;
      if (addBtn) {
        addBtn.disabled = !chosen.available;
        addBtn.textContent = chosen.available ? (addBtn.getAttribute('data-label') || 'Add to cart') : 'Sold out';
      }
      if (priceEl) priceEl.textContent = money(chosen.price, fmt);

      var q = qtySelect ? parseQty(qtySelect.value) : 1;
      if (unitEl) unitEl.textContent = q > 1 ? money(chosen.price / q, fmt) + ' / piece' : '';

      // Recompute every tier row against the currently selected non-quantity options
      var cheapestUnit = null;
      tierRows.forEach(function (row) {
        var val = row.getAttribute('data-tier-value');
        var v = findVariant(qtyIndex, val);
        var unit = row.querySelector('[data-tier-unit]');
        var total = row.querySelector('[data-tier-total]');
        if (!v) {
          row.style.display = 'none';
          return;
        }
        row.style.display = '';
        var rq = parseQty(val);
        var perUnit = v.price / rq;
        if (cheapestUnit === null || perUnit < cheapestUnit) cheapestUnit = perUnit;
        if (unit) unit.textContent = money(perUnit, fmt) + ' / piece';
        if (total) total.textContent = money(v.price, fmt);
        row.setAttribute('aria-pressed', v.id === chosen.id ? 'true' : 'false');
      });

      var url = new URL(window.location.href);
      url.searchParams.set('variant', chosen.id);
      window.history.replaceState({}, '', url);
    }

    selects.forEach(function (s) { s.addEventListener('change', render); });

    tierRows.forEach(function (row) {
      function pick() {
        if (!qtySelect) return;
        qtySelect.value = row.getAttribute('data-tier-value');
        render();
      }
      row.addEventListener('click', pick);
      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
      });
    });

    render();
  });


  /* ---- Artwork upload dropzone ---- */
  document.querySelectorAll('[data-dropzone]').forEach(function (zone) {
    var input = zone.querySelector('[data-dropzone-input]');
    var idle = zone.querySelector('[data-dropzone-idle]');
    var fileRow = zone.querySelector('[data-dropzone-file]');
    var nameEl = zone.querySelector('[data-dropzone-name]');
    var clear = zone.querySelector('[data-dropzone-clear]');
    if (!input) return;

    function paint() {
      var f = input.files && input.files[0];
      if (idle) idle.hidden = !!f;
      if (fileRow) fileRow.hidden = !f;
      if (f && nameEl) {
        var kb = f.size > 1048576 ? (f.size / 1048576).toFixed(1) + ' MB' : Math.round(f.size / 1024) + ' KB';
        nameEl.textContent = f.name + ' \u00b7 ' + kb;
      }
      zone.classList.remove('is-over');
    }

    input.addEventListener('change', paint);
    ['dragenter', 'dragover'].forEach(function (ev) {
      zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.remove('is-over'); });
    });
    zone.addEventListener('drop', function (e) {
      if (!e.dataTransfer || !e.dataTransfer.files.length) return;
      input.files = e.dataTransfer.files;
      paint();
    });
    if (clear) clear.addEventListener('click', function () { input.value = ''; paint(); });
    paint();
  });

  /* ---- Swatch buttons proxy to a hidden select ---- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-swatch]');
    if (!sw) return;
    var sel = document.getElementById(sw.getAttribute('data-swatch-for'));
    if (!sel) return;
    sel.value = sw.getAttribute('data-swatch');
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    sw.parentElement.querySelectorAll('[data-swatch]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === sw ? 'true' : 'false');
    });
  });

  /* ---- Cart quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var step = parseInt(b.getAttribute('data-qty-step'), 10);
    var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    if (input.form) input.form.submit();
  });

  /* ---- Filter dropdowns: close others ---- */
  document.addEventListener('toggle', function (e) {
    if (!e.target.matches || !e.target.matches('.filter')) return;
    if (!e.target.open) return;
    document.querySelectorAll('.filter[open]').forEach(function (d) { if (d !== e.target) d.removeAttribute('open'); });
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.filter')) return;
    document.querySelectorAll('.filter[open]').forEach(function (d) { d.removeAttribute('open'); });
  });

  /* ---- Auto-submit filter forms ---- */
  document.querySelectorAll('[data-filter-form]').forEach(function (f) {
    f.addEventListener('change', function () { f.submit(); });
  });
})();

